import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import JobDashboardActions from '../../dashboards/job/actions';
import notification from '@tt/components/Notification';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';

function* fetchProductionOperations({ productionOperationsParams }) {
  try {
    yield put(Actions.setProductionOperationsLoaderStatus({ productionOperationsLoader: true }));
    const { data } = yield call(api.get, {
      route: 'production/getsearched',
      params: productionOperationsParams,
    });
    const productionOperationsData = data;
    yield put(Actions.setProductionOperations({ productionOperationsData }));
    yield put(Actions.setProductionOperationsLoaderStatus({ productionOperationsLoader: false }));
  } catch (err) {
    yield put(Actions.setProductionOperationsLoaderStatus({ productionOperationsLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* fetchShiftProduction({ shiftProductionParams }) {
  try {
    yield put(Actions.setProductionOperationsLoaderStatus({ productionOperationsLoader: true }));
    const { data } = yield call(api.get, {
      route: 'production/getProduction',
      params: shiftProductionParams,
    });
    const shiftProductionData = data;
    yield put(Actions.setShiftProduction({ shiftProductionData, shiftProductionParams }));
    yield put(Actions.setProductionOperationsLoaderStatus({ productionOperationsLoader: false }));
  } catch (err) {
    yield put(Actions.setProductionOperationsLoaderStatus({ productionOperationsLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* addUpdateProductionOperation({ actionName, productionOperationObj, productionOperationsParams }) {
  try {
    yield put(Actions.setProductionOperationsLoaderStatus({ productionOperationsLoader: true }));
    yield call(actionName === CONSTANT_VARIABLES.UPDATE ? api.put : api.post, {
      route: `production`,
      data: productionOperationObj,
    });
    yield put(Actions.fetchProductionOperations({ productionOperationsParams }));
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.UPDATE
        ? CONSTANT_VARIABLES.PRODUCTION_UPDATED
        : CONSTANT_VARIABLES.PRODUCTION_CREATED,
      ''
    );
  } catch (err) {
    yield put(Actions.setProductionOperationsLoaderStatus({ productionOperationsLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* addJobProduction({ productionData, jobGridParams }) {
  try {
    yield put(Actions.setProductionOperationsLoaderStatus({ productionOperationsLoader: true }));
    yield call(api.post, {
      route: `production`,
      data: productionData,
    });
    yield put(JobDashboardActions.setLoader({ showLoader: true }));
    yield put(JobDashboardActions.fetchJobGrid({ jobGridParams }));
    yield put(Actions.setProductionOperationsLoaderStatus({ productionOperationsLoader: false }));
    notification('success', CONSTANT_VARIABLES.JOB_PRODUCTION_ADDED, '');
  } catch (err) {
    yield put(Actions.setProductionOperationsLoaderStatus({ productionOperationsLoader: false }));
    yield put(JobDashboardActions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* deleteProductionOperation({ productionId, productionOperationsParams }) {
  try {
    yield put(Actions.setProductionOperationsLoaderStatus({ productionOperationsLoader: true }));
    yield call(api.delete, {
      route: `production/${productionId}`,
    });
    yield put(Actions.fetchProductionOperations({ productionOperationsParams }));
    notification('success', CONSTANT_VARIABLES.PRODUCTION_DELETED, '');
  } catch (err) {
    yield put(Actions.setProductionOperationsLoaderStatus({ productionOperationsLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* fetchProductionHours({ productionHoursParams }) {
  try {
    yield put(Actions.setProductionOperationsLoaderStatus({ productionOperationsLoader: true }));
    const { data } = yield call(api.get, {
      route:
        'production/GetProductionShiftHours/' +
        productionHoursParams.factoryId +
        '/' +
        productionHoursParams.equipmentId +
        '/' +
        productionHoursParams.equipmentShiftId +
        '/' +
        productionHoursParams.jobId,
    });
    const productionHoursData = data;
    yield put(Actions.setProductionHours({ productionHoursData }));
    yield put(Actions.setProductionOperationsLoaderStatus({ productionOperationsLoader: false }));
  } catch (err) {
    yield put(Actions.setProductionOperationsLoaderStatus({ productionOperationsLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}
function* fetchProductionShifts({ productionShiftsParams }) {
  try {
    yield put(Actions.setProductionOperationsLoaderStatus({ productionOperationsLoader: true }));
    const { data } = yield call(api.get, {
      route:
        'production/FactoryEquipmentProductionShifts/' +
        productionShiftsParams.factoryId +
        '/' +
        productionShiftsParams.equipmentId +
        '/' +
        productionShiftsParams.date +
        '/' +
        productionShiftsParams.jobId,
    });
    const productionShiftsData = data;
    yield put(Actions.setProductionShifts({ productionShiftsData }));
    yield put(Actions.setProductionOperationsLoaderStatus({ productionOperationsLoader: false }));
  } catch (err) {
    yield put(Actions.setProductionOperationsLoaderStatus({ productionOperationsLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* fetchOeesProductionDates({ productionParams }) {
  try {
    yield put(Actions.setProductionOperationsLoaderStatus({ productionOperationsLoader: true }));
    const { data } = yield call(api.get, {
      route:
        'production/LastFifteenDaysProduction/' +
        productionParams.factoryId +
        '/' +
        productionParams.equipmentId +
        '/' +
        productionParams.jobId,
    });
    const productionData = data;
    yield put(Actions.setOeesProductionDates({ productionData }));
    yield put(Actions.setProductionOperationsLoaderStatus({ productionOperationsLoader: false }));
  } catch (err) {
    yield put(Actions.setProductionOperationsLoaderStatus({ productionOperationsLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_PRODUCTION_OPERATIONS, fetchProductionOperations),
    takeLatest(ActionTypes.FETCH_SHIFT_PRODUCTION, fetchShiftProduction),
    takeLatest(ActionTypes.ADD_UPDATE_PRODUCTION_OPERATION, addUpdateProductionOperation),
    takeLatest(ActionTypes.ADD_JOB_PRODUCTION, addJobProduction),
    takeLatest(ActionTypes.DELETE_PRODUCTION_OPERATION, deleteProductionOperation),
    takeLatest(ActionTypes.FETCH_OEE_PRODUCTION_DATES, fetchOeesProductionDates),
    takeLatest(ActionTypes.FETCH_PRODUCTION_HOURS, fetchProductionHours),
    takeLatest(ActionTypes.FETCH_PRODUCTION_SHIFTS, fetchProductionShifts),
  ]);
}
